import DOMPurify from "dompurify";

const EMAIL_ALLOWED_TAGS = [
  // headers
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  // Text formatting
  "b",
  "blockquote",
  "br",
  "em",
  "i",
  "p",
  "span",
  "strike",
  "strong",
  "u",
  // Layout
  "div",
  "hr",
  "table",
  "tbody",
  "td",
  "th",
  "thead",
  "tr",
  // Media & Links
  "a",
  "img",
  // Lists
  "li",
  "ol",
  "ul",
];

// Chosen for email layout, not inherited from DOMPurify's default union (which admits
// class/id/role/tabindex — e.g. class="ant-modal-mask" would paint the app's own overlay
// CSS over the page). Omitting ALLOWED_ATTR entirely is what every email surface renders,
// so this list is load-bearing.
const EMAIL_ALLOWED_ATTR = [
  "align",
  "alt",
  "background",
  "bgcolor",
  "border",
  "cellpadding",
  "cellspacing",
  "color",
  "colspan",
  "dir",
  "face",
  "height",
  "href",
  "lang",
  "nowrap",
  "rel",
  "rowspan",
  "size",
  "src",
  "style",
  "target",
  "title",
  "valign",
  "width",
];

// Default sanitization strips target, so email links would open in the same tab and
// navigate the user out of the CRM. Force a safe target/rel rather than trusting the
// incoming pair. Inert for the app's other DOMPurify configs — none allows target, so
// no sanitized node reaches this hook carrying one.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.hasAttribute("target")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

const sanitizeEmailHtml = (html: string) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_ATTR: EMAIL_ALLOWED_ATTR,
    ALLOWED_TAGS: EMAIL_ALLOWED_TAGS,
  });
};

export default sanitizeEmailHtml;
